module.exports = __webpack_public_path__ + "img/genesis-drop-impostor-4.77d29f00.webp";